import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomNavbar from "../../components/CustomNavbar";
// import SidebarCapacitacion from "../../components/capacitacionDesarrollo/SidebarCapacitacion";
import SidebarDashboard from "../../components/SidebarDashboard";
import Multiselect from "../../components/MultiselectFormik";

import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Breadcrumb,
  Tabs,
  Tab,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import messages from "../../redux/messages";

//redux
import {
  getTrainingEvents,
  saveTrainingEvents,
  editTrainingEvents,
  deleteTrainingEvents,
  getEmployeesResponsible,
} from "../../redux/capacitacionDesarrollo/TrainingEvents/actions";

import { getTrainingAssistance } from "../../redux/capacitacionDesarrollo/Training_assistance/actions";

import { getInstitute } from "../../redux/institute/actions";
import { getFuncFormations } from "../../redux/func_formacion/actions";
import { getCollegeDegree } from "../../redux/collegedegree/actions";
import { getSpecialization } from "../../redux/specialization/actions";
import { getCompanias } from "../../redux/compania/actions";

import { useHistory } from "react-router-dom";
import { getTrainingType } from "../../redux/capacitacionDesarrollo/trainng_type/actions";
import { getTrainings } from "../../redux/capacitacionDesarrollo/trainings/actions";
import { getApproaches } from "../../redux/capacitacionDesarrollo/approaches/actions";
import { getOrigins } from "../../redux/capacitacionDesarrollo/origins/actions";
import { getModalities } from "../../redux/capacitacionDesarrollo/modalities/actions";
import { Typeahead } from "react-bootstrap-typeahead";

import LinkDescargaCapacitacion from "../../components/capacitacionDesarrollo/LinkDescargaCapacitacion";

const TrainingEvents = (props) => {
  // Tipo de busqueda para filter
  const filters = [
    { id: "nombre_evento", desc: "Nombre del evento" },
    // { id: "ruta_capacitacion", desc: "Ruta de capacitación"},
    { id: "responsable_nombre", desc: "Nombre responsable" },
    { id: "responsable_codigo", desc: "Codigo del Responsable" },
    { id: "numero_empleados_recibir", desc: "Convocados" },
    { id: "fecha_inicio", desc: "Fecha de inicio" },
    { id: "fecha_fin", desc: "Fecha finalización" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
    { id: "duracion_horas", desc: "Horas" },
  ];

  // Variables de hooks
  const [show, setShow] = useState(true);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [empSelected, setEmpSelected] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [showModalAcceptEstado, setShowModalAcceptEstado] = useState(false);
  const [companiesGroup, setCompaniesGroup] = useState([]);

  // Shema de Yup
  const schema = Yup.object().shape({
    tipo_capacitacion: Yup.string().ensure().required("**Campo requerido"),
    capacitacion: Yup.string().ensure().required("**Campo requerido"),
    enfoque: Yup.string().ensure().required("**Campo requerido"),
    origen: Yup.string().ensure().required("**Campo requerido"),
    nivel_formacion: Yup.string().ensure().required("**Campo requerido"),
    formacion: Yup.string().ensure().required("**Campo requerido"),
    titulo: Yup.string().ensure().required("**Campo requerido"),
    especialidad: Yup.string().ensure().required("**Campo requerido"),
    modalidad: Yup.string().ensure().required("**Campo requerido"),
    responsable: Yup.string().ensure().required("**Campo requerido"),
    fecha_inicio: Yup.string().ensure().required("**Campo requerido"),
    fecha_fin: Yup.string().ensure().required("**Campo requerido"),
    duracion_horas: Yup.number().required("**Campo requerido"),
    horas_cumplidas: Yup.number().notRequired(""),
    meta_horas: Yup.number().notRequired(""),
    impartido_por: Yup.string().ensure().required("**Campo requerido"),
    facilitador: Yup.string().ensure().required("**Campo requerido"),
    objetivo_capacitacion: Yup.string().ensure().required("**Campo requerido"),
    tema_capacitacion: Yup.string().ensure().required("**Campo requerido"),
    costo_capacitacion: Yup.number().notRequired(""),
    costo_empleado: Yup.number().notRequired(""),
    numero_empleados_recibir: Yup.number().required("**Campo requerido"),
    porcentaje_asistencia: Yup.number().notRequired(""),
    es_evaluacion: Yup.boolean().notRequired(""),
    nota_aprovatoria: Yup.number()
      .integer("El campo no debe llevar decimales")
      .min(0, "El valor minimo es 0.")
      // .required("**Campo requerido")
      .max(100, "El valor maximo es 100"),
    hora_capacitacion: Yup.string()
      .min(0, "El valor minimo es 0.")
      .required("**Campo requerido"),
    nombre_evento_capacitacion: Yup.string()
      .ensure()
      .required("**Campo requerido"),
    dias_evaluacion: Yup.string().when("es_evaluacion", {
      is: true,
      then: Yup.string().required("**Campo requerido"),
    }),
    list_empresas: Yup.array().test({
      message: "**Campo requerido",
      test: (val) => val.length !== 0,
    }),
    lugar: Yup.string().notRequired(),
    // .required("**Campo requerido"),
  });

  const schemaAcceptEstado = Yup.object().shape({
    dias: Yup.number()
      .integer("El campo no debe llevar decimales")
      .min(0, "El valor minimo es 0."),
  });

  const dispatch = useDispatch();
  const history = useHistory();

  // Variables de redux
  const {
    loaderTrainingEvents,
    loaderPersonResponsible,
    trainingEvents,
    personResponsible,
    trainingEventsFalla,
    saveLoaderTrainingEvents,
    trainingEventsFormError,
  } = useSelector((store) => store.trainingEvents);

  const pages = Math.ceil((trainingEvents ? trainingEvents.count : 0) / limit);

  const { loaderTrainingType, trainingType } = useSelector(
    (store) => store.trainingType
  );
  const { loaderTrainings, trainings } = useSelector(
    (store) => store.trainings
  );

  const { loaderApproaches, approaches } = useSelector(
    (store) => store.approaches
  );

  const { loaderOrigins, origins } = useSelector((store) => store.origins);

  const { loading: loaderInstitute, institute } = useSelector(
    (store) => store.institute
  );

  const { loader: loaderFormations, Formations: formations } = useSelector(
    (store) => store.funcFormation
  );

  const { loading: loaderCollegeDegree, collegeDegree } = useSelector(
    (store) => store.collegeDegree
  );

  const { loading: loaderSpecialization, specialization } = useSelector(
    (store) => store.specialization
  );

  const { loaderModalities, modalities } = useSelector(
    (store) => store.modalities
  );

  const { loaderTrainingAssistance, trainingAssistance } = useSelector(
    (store) => store.trainingAssistance
  );

  const userRoles = useSelector((store) => store.auth.userRoles);

  const { compania, companiaLoader } = useSelector((store) => store.compania);
  // const { loading: loaderEmployees, employees } = useSelector(
  //   (store) => store.employees
  // );

  let employeesOptions = [];
  personResponsible &&
    personResponsible.data.map((item) => {
      employeesOptions = [
        ...employeesOptions,
        {
          id: item.id,
          label: `${item.codigo} / ${item.nombre}`,
          item: item,
        },
      ];
    });

  let empresasOptions = [];

  compania.map((item) => {
    empresasOptions = [
      ...empresasOptions,
      { value: item.id, label: `${item.codigo}/${item.nombre}` },
    ];
  });

  // Columnas para custom table
  const columns = [
    // {
    //   Header: "Código",
    //   // accessor: "codigo",
    //   Filter: "",
    //   Cell: (value) => (
    //     <div>
    //       {value.row.original.campania
    //         ? value.row.original.list_capacitacion[0].codigo_capacitacion
    //         : ""}
    //     </div>
    //   ),
    // },
    {
      Header: "Nombre",
      // accessor: "nombre_evento",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.campania
            ? value.row.original.nombre_evento_capacitacion
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha de inicio",
      accessor: "fecha_inicio",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_inicio).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Fecha finalización",
      accessor: "fecha_fin",
      Filter: "",
      Cell: (value) => (
        <div>{moment(value.row.original.fecha_fin).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      Header: "Horas de duración",
      accessor: "duracion_horas",
      Filter: "",
    },
    {
      Header: "Convocados",
      accessor: "numero_empleados_recibir",
      Filter: "",
    },
    {
      Header: "Responsable",
      // accessor: "numero_empleados_recibir",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.responsable
            ? value.row.original.list_responsable[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Estado:",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${
            value.row.original.estado && value.row.original.list_estado[0]
              ? "p-2 rounded-pill text-white"
              : ""
          } text-center`}
          style={{
            backgroundColor:
              value.row.original.estado && value.row.original.list_estado[0]
                ? value.row.original.list_estado[0].color
                : "",
            minWidth: "90px",
          }}
        >
          {value.row.original.estado && value.row.original.list_estado[0]
            ? value.row.original.list_estado[0].descripcion
            : "Sin estado"}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      // accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group d-flex" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          {/* {value.row.original.campania &&
          value.row.original.list_campania[0].estado &&
          value.row.original.list_campania[0].list_estado[0].descripcion.toLowerCase() !==
            "cerrado" ? ( */}
          {value.row.original.estado &&
          value.row.original.list_estado[0].descripcion.toLowerCase() !==
            "cerrado" ? (
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          ) : null}
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Convocados a capacitacion</Tooltip>}
          >
            <Button
              size="sm"
              className="text-info"
              variant="link"
              type="button"
              onClick={() =>
                history.push(
                  `/capacitacion-desarrollo/asistencia-capacitacion/${value.row.original.id}/${value.row.original.list_capacitacion[0].codigo_capacitacion}`
                )
              }
            >
              <i className="material-icons">article</i>
            </Button>
          </OverlayTrigger>

          {/* <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Extender días</Tooltip>}
          >
            <Button
              size="sm"
              className="text-info"
              variant="link"
              type="button"
              onClick={() => setShowModalAcceptEstado(true)
              }
            >
              <i className="material-icons">expand</i>
            </Button>
          </OverlayTrigger> */}

          <LinkDescargaCapacitacion id={value.row.original.id} />
        </div>
      ),
    },
  ];

  // Metodos
  const _getTrainingEvents = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getTrainingEvents({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion" ||
          tipoBusqueda.id === "fecha_inicio" ||
          tipoBusqueda.id === "fecha_fin"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
        filter_2: parseInt(props.match.params.idCampania),
      })
    );

  useEffect(() => {
    _getTrainingEvents();
    dispatch(getTrainingType({}));
    dispatch(getTrainings({}));
    dispatch(getApproaches({}));
    dispatch(getOrigins({}));
    dispatch(getInstitute({}, 2));
    dispatch(getModalities({}));
    // dispatch(getAllActiveEmployees({}));
    dispatch(getCompanias(2));
  }, []);

  useEffect(() => {
    let filters = {
      filter: "Responsable_Capacitacion",
    };
    if (userRoles.includes("Responsable_Capacitacion")) {
      filters.usuario_x_empresa = "si";
    }
    dispatch(getEmployeesResponsible(filters));
  }, [userRoles]);

  const onAdd = () => {
    setEmpSelected([]);
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
    setCompaniesGroup([]);
  };

  const onEdit = (item, index) => {
    dispatch(
      getTrainingAssistance({
        tipo_busqueda: "evento_capacitacion__id",
        filter: item.id,
      })
    );
    let companies = [];
    item?.list_empresas_eventos &&
      item.list_empresas_eventos.map((empresa) => {
        companies.push({ value: empresa.id });
      });
    setCompaniesGroup(companies);
    if (item.responsable) {
      setEmpSelected([
        {
          id: item.responsable,
          label: `${item.list_responsable[0].codigo} / ${item.list_responsable[0].nombre}`,
          item: item.list_responsable[0],
        },
      ]);
    }
    if (item.nivel_formacion) {
      dispatch(
        getFuncFormations({ instituto: parseInt(item.nivel_formacion) }, 2)
      );
      dispatch(
        getCollegeDegree({ instituto: parseInt(item.nivel_formacion) }, 2)
      );
      dispatch(
        getSpecialization({ instituto: parseInt(item.nivel_formacion) }, 2)
      );
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  // const eliminarPorName = (name, jsonVar) => {
  //   jsonVar.hobbies.forEach(function (currentValue, index, arr) {
  //     if (jsonVar.hobbies[index].name == name) {
  //       jsonVar.hobbies.splice(index, index);
  //     }
  //   });
  // };

  const onSubmit = (req) => {
    if (
      edit &&
      trainingAssistance &&
      trainingAssistance.count > parseInt(req.numero_empleados_recibir)
    ) {
      toastr.info(
        "El número de empleados a recibir no puede ser menor al total de personas agregadas a la lista"
      );
      return;
    }

    if (moment(req.fecha_inicio) > moment(req.fecha_fin)) {
      toastr.info("La fecha inicio no pueder ser mayor a la fecha fin");
      return;
    }
    if (req.costo_capacitacion === "") {
      req.costo_capacitacion = null;
    }
    if (req.costo_empleado === "") {
      req.costo_empleado = null;
    }
    if (req.dias_evaluacion === "") {
      req.dias_evaluacion = null;
    }
    if (req.horas_cumplidas === "") {
      req.horas_cumplidas = null;
    }
    if (req.meta_horas === "") {
      req.meta_horas = null;
    }
    if (req.porcentaje_asistencia === "") {
      req.porcentaje_asistencia = null;
    }
    if (req.nota_aprovatoria === "") {
      req.nota_aprovatoria = null;
    }
    if (!req.es_evaluacion) {
      req.dias_evaluacion = null;
    }

    let companies = [];

    req.list_empresas.map((item) => {
      companies.push(parseInt(item.value));
    });

    req.listado_empresas = companies;
    delete req.list_empresas;
    if (!edit) {
      req.campania = parseInt(props.match.params.idCampania);
      dispatch(saveTrainingEvents(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      if (
        editItem.list_estado[0].descripcion.toLowerCase() === "cerrado" &&
        userRoles.length > 0 &&
        (userRoles.includes("administrador") ||
          userRoles.includes("Responsable_Capacitacion"))
      ) {
        req.job = true;
      }
      dispatch(editTrainingEvents(req, index, setShowFormModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTrainingEvents(oOffset, limit, oSearch);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTrainingEvents(oOffset, limit, e.target.filter.value);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      if (window.confirm("¿Está seguro que quiere eliminar este registro?")) {
        if (
          window.confirm(
            "¿Si elimina este registro, se eliminarán todas las asistencias asociadas, desea continuar?"
          )
        ) {
          dispatch(deleteTrainingEvents(id, data));
        }
      }
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mb-4 px-2">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() => history.goBack()}
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  // onClick={() =>
                  //   history.push(`/descriptores-perfiles/menu-usuario`)
                  // }
                  className="text-uppercase"
                  onClick={() => history.goBack()}
                >
                  Rutas de capacitación
                </Breadcrumb.Item>
                <Breadcrumb.Item active title className="text-uppercase">
                  {/* {props.match.params.nombre} */}
                  Eventos de capacitación
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <hr />
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              {props.match.params.codigoCampania}-
              {props.match.params.nombreCampania}
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!trainingEventsFalla && (
            <Alert variant="danger" className="mt-4 mb-1">
              {trainingEventsFalla}
            </Alert>
          )}
          {loaderTrainingEvents ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : trainingEvents != null &&
            trainingEvents.data &&
            trainingEvents.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={trainingEvents.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={trainingEvents.count}
                pages={pages}
                pagFunc={_getTrainingEvents}
              />
            </>
          ) : (
            <>
              {!trainingEventsFalla && (
                <Alert variant="info" className="my-4">
                  Aún no hay registros, comience creando algunos.
                </Alert>
              )}
            </>
          )}
        </Container>
      </div>
      {/*Modal*/}
      <Modal
        size="lg"
        show={showFormModal}
        onHide={() => setShowFormModal(false)}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            tipo_capacitacion: edit ? editItem.tipo_capacitacion : "",
            capacitacion: edit ? editItem.capacitacion : "",
            enfoque: edit ? editItem.enfoque : "",
            origen: edit ? editItem.origen : "",
            nivel_formacion: edit ? editItem.nivel_formacion : "",
            formacion: edit ? editItem.formacion : "",
            titulo: edit ? editItem.titulo : "",
            especialidad: edit ? editItem.especialidad : "",
            modalidad: edit ? editItem.modalidad : "",
            responsable: edit ? editItem.responsable : "",
            fecha_inicio: edit ? editItem.fecha_inicio : "",
            fecha_fin: edit ? editItem.fecha_fin : "",
            duracion_horas: edit
              ? editItem.duracion_horas
                ? editItem.duracion_horas
                : 0
              : "",
            horas_cumplidas: edit
              ? editItem.horas_cumplidas
                ? parseFloat(editItem.horas_cumplidas).toFixed(2)
                : 0
              : "",
            meta_horas: edit
              ? editItem.meta_horas
                ? parseFloat(editItem.meta_horas).toFixed(2)
                : 0
              : "",
            impartido_por: edit ? editItem.impartido_por : "",
            facilitador: edit ? editItem.facilitador : "",
            costo_capacitacion: edit
              ? editItem.costo_capacitacion
                ? editItem.costo_capacitacion
                : ""
              : "",
            costo_empleado: edit
              ? editItem.costo_empleado
                ? parseFloat(editItem.costo_empleado).toFixed(2)
                : ""
              : "",
            numero_empleados_recibir: edit
              ? editItem.numero_empleados_recibir
                ? editItem.numero_empleados_recibir
                : ""
              : "",
            porcentaje_asistencia: edit
              ? editItem.porcentaje_asistencia
                ? parseFloat(editItem.porcentaje_asistencia).toFixed(2)
                : ""
              : "",
            dias_evaluacion: edit
              ? editItem.dias_evaluacion
                ? editItem.dias_evaluacion
                : ""
              : 90,
            // es_evaluacion: false,
            es_evaluacion: edit ? editItem.es_evaluacion : false,
            nota_aprovatoria: edit
              ? editItem.nota_aprovatoria
                ? editItem.nota_aprovatoria
                : ""
              : "",
            hora_capacitacion: edit
              ? editItem.hora_capacitacion
                ? editItem.hora_capacitacion
                : ""
              : "",
            nombre_evento_capacitacion: edit
              ? editItem.nombre_evento_capacitacion
              : "",
            clave_pais: edit ? editItem.clave_pais : "",
            objetivo_capacitacion: edit ? editItem.objetivo_capacitacion : "",
            tema_capacitacion: edit ? editItem.tema_capacitacion : "",
            list_empresas: edit ? companiesGroup : [],
            lugar: edit ? editItem.lugar : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            handleBlur,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar evento" : "Crear evento"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {trainingEventsFormError &&
                typeof trainingEventsFormError !== "object" ? (
                  <Alert variant="danger" className="my-2">
                    {trainingEventsFormError}
                  </Alert>
                ) : null}
                {edit &&
                  editItem.estado &&
                  editItem.list_estado[0].descripcion.toLowerCase() ===
                    "cerrado" && (
                    <Alert variant="info" className=" mb-3">
                      No se puede editar ya que el evento ha finalizado
                    </Alert>
                  )}
                <Tabs
                  defaultActiveKey="detalle"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="detalle" title="Detalle capacitación">
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Nombre capacitación
                            </Form.Label>
                            <Form.Control
                              id="nombre_evento_capacitacion"
                              name="nombre_evento_capacitacion"
                              isInvalid={
                                touched.nombre_evento_capacitacion &&
                                errors.nombre_evento_capacitacion
                              }
                              isValid={
                                touched.nombre_evento_capacitacion &&
                                !errors.nombre_evento_capacitacion
                              }
                              onBlur={handleBlur("nombre_evento_capacitacion")}
                              onChange={handleChange}
                              value={values.nombre_evento_capacitacion}
                              type="text"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.nombre_evento_capacitacion &&
                              !!errors.nombre_evento_capacitacion && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.nombre_evento_capacitacion}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderTrainingType ? "10" : "12"}>
                            <Form.Label className="ml-2">
                              Tipo de capacitacion
                            </Form.Label>
                            <Form.Control
                              id="tipo_capacitacion"
                              name="tipo_capacitacion"
                              isInvalid={
                                touched.tipo_capacitacion &&
                                errors.tipo_capacitacion
                              }
                              isValid={
                                touched.tipo_capacitacion &&
                                !errors.tipo_capacitacion
                              }
                              onBlur={handleBlur("tipo_capacitacion")}
                              onChange={handleChange}
                              value={values.tipo_capacitacion}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione un tipo de capacitación
                              </option>
                              {trainingType &&
                                trainingType.data.map((item, index) => (
                                  <option
                                    key={item.id ? item.id : index}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.descripcion}
                                  </option>
                                ))}
                            </Form.Control>
                            {touched.tipo_capacitacion &&
                              !!errors.tipo_capacitacion && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.tipo_capacitacion}
                                  </small>
                                </div>
                              )}
                          </Col>
                          {loaderTrainingType && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderApproaches ? "10" : "12"}>
                            <Form.Label className="ml-2">Enfoque</Form.Label>
                            <Form.Control
                              id="enfoque"
                              name="enfoque"
                              isInvalid={touched.enfoque && errors.enfoque}
                              isValid={touched.enfoque && !errors.enfoque}
                              onBlur={handleBlur("enfoque")}
                              onChange={handleChange}
                              value={values.enfoque}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione un enfoque
                              </option>
                              {approaches &&
                                approaches.data
                                  .sort((a, b) =>
                                    a.descripcion > b.descripcion
                                      ? 1
                                      : b.descripcion > a.descripcion
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={item.id ? item.id : index}
                                      value={item.id ? item.id : ""}
                                    >
                                      {item.descripcion}
                                    </option>
                                  ))}
                            </Form.Control>
                            {touched.enfoque && !!errors.enfoque && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.enfoque}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderApproaches && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderTrainings ? "10" : "12"}>
                            <Form.Label className="ml-2">
                              Competencia a desarrollar
                            </Form.Label>
                            <Form.Control
                              id="capacitacion"
                              name="capacitacion"
                              isInvalid={
                                touched.capacitacion && errors.capacitacion
                              }
                              isValid={
                                touched.capacitacion && !errors.capacitacion
                              }
                              onBlur={handleBlur("capacitacion")}
                              onChange={handleChange}
                              value={values.capacitacion}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione una capacitación
                              </option>
                              {trainings &&
                                trainings.data
                                  .sort((a, b) =>
                                    a.nombre_capacitacion >
                                    b.nombre_capacitacion
                                      ? 1
                                      : b.nombre_capacitacion >
                                        a.nombre_capacitacion
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={item.id ? item.id : index}
                                      value={item.id ? item.id : ""}
                                    >
                                      {item.nombre_capacitacion}
                                    </option>
                                  ))}
                            </Form.Control>
                            {touched.capacitacion && !!errors.capacitacion && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.capacitacion}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderTrainings && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderOrigins ? "10" : "12"}>
                            <Form.Label className="ml-2">Origen</Form.Label>
                            <Form.Control
                              id="origen"
                              name="origen"
                              isInvalid={touched.origen && errors.origen}
                              isValid={touched.origen && !errors.origen}
                              onBlur={handleBlur("origen")}
                              onChange={handleChange}
                              value={values.origen}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione un origen
                              </option>
                              {origins &&
                                origins.data
                                  .sort((a, b) =>
                                    a.descripcion > b.descripcion
                                      ? 1
                                      : b.descripcion > a.descripcion
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={item.id ? item.id : index}
                                      value={item.id ? item.id : ""}
                                    >
                                      {item.descripcion}
                                    </option>
                                  ))}
                            </Form.Control>
                            {touched.origen && !!errors.origen && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.origen}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderOrigins && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Clave de país
                            </Form.Label>
                            <Form.Control
                              id="clave_pais"
                              name="clave_pais"
                              isInvalid={
                                touched.clave_pais && errors.clave_pais
                              }
                              isValid={touched.clave_pais && !errors.clave_pais}
                              onBlur={handleBlur("clave_pais")}
                              onChange={handleChange}
                              value={
                                values.clave_pais ? values.clave_pais : "HN"
                              }
                              type="text"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.clave_pais && !!errors.clave_pais && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.clave_pais}
                                </small>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} lg={6}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">Empresa</Form.Label>
                            <Multiselect
                              id="list_empresas"
                              name="list_empresas"
                              options={empresasOptions}
                              value={values.list_empresas}
                              onChange={(selected) => {
                                setFieldValue(
                                  "list_empresas",
                                  selected.length > 0 ? selected : []
                                );
                              }}
                              isDisabled={
                                edit &&
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                              isValid={
                                touched.list_empresas && !errors.list_empresas
                              }
                              isInvalid={
                                touched.list_empresas && errors.list_empresas
                              }
                              onBlur={() => handleBlur("list_empresas")}
                            />
                            {touched.list_empresas && errors.list_empresas && (
                              <small className="mx-2 text-danger">
                                {errors.list_empresas}
                              </small>
                            )}
                          </Col>
                        </Row>
                      </Form.Group>

                      <Form.Group as={Col} lg={6}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Lugar
                            </Form.Label>
                            <Form.Control
                              id="lugar"
                              name="lugar"
                              isInvalid={touched.lugar && errors.lugar}
                              isValid={touched.lugar && !errors.lugar}
                              onBlur={handleBlur("lugar")}
                              onChange={handleChange}
                              value={values.lugar}
                              type="text"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                              placeholder="Ubicación física o enlace virtual"
                            />
                            {!errors.lugar && (
                              <div className="px-2">
                                <small className="text-info">**Opcional</small>
                              </div>
                            )}
                            {touched.lugar && !!errors.lugar && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.lugar}
                                </small>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Form.Group>
                    </Row>
                  </Tab>

                  <Tab eventKey="formacion" title="Formación académica">
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderInstitute ? "10" : "12"}>
                            <Form.Label className="ml-2">
                              Nivel de formación
                            </Form.Label>
                            <Form.Control
                              id="nivel_formacion"
                              name="nivel_formacion"
                              isInvalid={
                                touched.nivel_formacion &&
                                errors.nivel_formacion
                              }
                              isValid={
                                touched.nivel_formacion &&
                                !errors.nivel_formacion
                              }
                              onBlur={handleBlur("nivel_formacion")}
                              onChange={(e) => {
                                dispatch(
                                  getFuncFormations(
                                    {
                                      instituto: parseInt(
                                        e.currentTarget.value
                                      ),
                                    },
                                    2
                                  )
                                );
                                dispatch(
                                  getCollegeDegree(
                                    {
                                      instituto: parseInt(
                                        e.currentTarget.value
                                      ),
                                    },
                                    2
                                  )
                                );
                                dispatch(
                                  getSpecialization(
                                    {
                                      instituto: parseInt(
                                        e.currentTarget.value
                                      ),
                                    },
                                    2
                                  )
                                );
                                handleChange(e);
                              }}
                              value={values.nivel_formacion}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione un nivel de formación
                              </option>
                              {institute
                                .sort((a, b) =>
                                  a.descripcion > b.descripcion
                                    ? 1
                                    : b.descripcion > a.descripcion
                                    ? -1
                                    : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={item.id ? item.id : index}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.descripcion}
                                  </option>
                                ))}
                            </Form.Control>
                            {touched.nivel_formacion &&
                              !!errors.nivel_formacion && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.nivel_formacion}
                                  </small>
                                </div>
                              )}
                          </Col>
                          {loaderInstitute && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderFormations ? "10" : "12"}>
                            <Form.Label className="ml-2">Formación</Form.Label>
                            <Form.Control
                              id="formacion"
                              name="formacion"
                              isInvalid={touched.formacion && errors.formacion}
                              isValid={touched.formacion && !errors.formacion}
                              onBlur={handleBlur("formacion")}
                              onChange={handleChange}
                              value={values.formacion}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                loaderFormations ||
                                values.nivel_formacion === "" ||
                                formations.length === 0 ||
                                // (edit &&
                                //   editItem.campania &&
                                //   editItem.list_campania[0].estado &&
                                //   editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //     "cerrado")
                                (edit &&
                                  editItem.estado &&
                                  editItem.list_estado[0].descripcion.toLowerCase() ===
                                    "cerrado")
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione una formación
                              </option>
                              {formations
                                .sort((a, b) =>
                                  a.descripcion > b.descripcion
                                    ? 1
                                    : b.descripcion > a.descripcion
                                    ? -1
                                    : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={item.id ? item.id : index}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.descripcion}
                                  </option>
                                ))}
                            </Form.Control>
                            {touched.formacion && !!errors.formacion && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.formacion}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderFormations && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderCollegeDegree ? "10" : "12"}>
                            <Form.Label className="ml-2">Título</Form.Label>
                            <Form.Control
                              id="titulo"
                              name="titulo"
                              isInvalid={touched.titulo && errors.titulo}
                              isValid={touched.titulo && !errors.titulo}
                              onBlur={handleBlur("titulo")}
                              onChange={handleChange}
                              value={values.titulo}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                loaderCollegeDegree ||
                                values.nivel_formacion === "" ||
                                collegeDegree.length === 0 ||
                                // (edit &&
                                //   editItem.campania &&
                                //   editItem.list_campania[0].estado &&
                                //   editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //     "cerrado")
                                (edit &&
                                  editItem.estado &&
                                  editItem.list_estado[0].descripcion.toLowerCase() ===
                                    "cerrado")
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione un título
                              </option>
                              {collegeDegree
                                .sort((a, b) =>
                                  a.descripcion > b.descripcion
                                    ? 1
                                    : b.descripcion > a.descripcion
                                    ? -1
                                    : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={item.id ? item.id : index}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.descripcion}
                                  </option>
                                ))}
                            </Form.Control>
                            {touched.titulo && !!errors.titulo && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.titulo}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderCollegeDegree && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderSpecialization ? "10" : "12"}>
                            <Form.Label className="ml-2">
                              Epecialidad
                            </Form.Label>
                            <Form.Control
                              id="especialidad"
                              name="especialidad"
                              isInvalid={
                                touched.especialidad && errors.especialidad
                              }
                              isValid={
                                touched.especialidad && !errors.especialidad
                              }
                              onBlur={handleBlur("especialidad")}
                              onChange={handleChange}
                              value={values.especialidad}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                loaderSpecialization ||
                                values.nivel_formacion === "" ||
                                specialization.length === 0 ||
                                // (edit &&
                                //   editItem.campania &&
                                //   editItem.list_campania[0].estado &&
                                //   editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //     "cerrado")
                                (edit &&
                                  editItem.estado &&
                                  editItem.list_estado[0].descripcion.toLowerCase() ===
                                    "cerrado")
                              }
                            >
                              <option value="" selected disabled>
                                Seleccione un epecialidad
                              </option>
                              {specialization
                                .sort((a, b) =>
                                  a.descripcion > b.descripcion
                                    ? 1
                                    : b.descripcion > a.descripcion
                                    ? -1
                                    : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={item.id ? item.id : index}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.descripcion}
                                  </option>
                                ))}
                            </Form.Control>
                            {touched.especialidad && !!errors.especialidad && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.especialidad}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderSpecialization && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderModalities ? "10" : "12"}>
                            <Form.Label className="ml-2">Modalidad</Form.Label>
                            <Form.Control
                              id="modalidad"
                              name="modalidad"
                              isInvalid={touched.modalidad && errors.modalidad}
                              isValid={touched.modalidad && !errors.modalidad}
                              onBlur={handleBlur("modalidad")}
                              onChange={handleChange}
                              value={values.modalidad}
                              as="select"
                              className="rounded-pill"
                              disabled={
                                loaderModalities ||
                                // (edit &&
                                //   editItem.campania &&
                                //   editItem.list_campania[0].estado &&
                                //   editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //     "cerrado")
                                (edit &&
                                  editItem.estado &&
                                  editItem.list_estado[0].descripcion.toLowerCase() ===
                                    "cerrado")
                              }
                            >
                              <option value="">Seleccione una modalidad</option>
                              {modalities &&
                                modalities.data
                                  .sort((a, b) =>
                                    a.descripcion > b.descripcion
                                      ? 1
                                      : b.descripcion > a.descripcion
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={item.id ? item.id : index}
                                      value={item.id ? item.id : ""}
                                    >
                                      {item.descripcion}
                                    </option>
                                  ))}
                            </Form.Control>
                            {touched.modalidad && !!errors.modalidad && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.modalidad}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderModalities && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col sm={loaderPersonResponsible ? "10" : "12"}>
                            <Form.Label className="ml-2">
                              Responsable
                            </Form.Label>
                            <Typeahead
                              id="responsable"
                              name="responsable"
                              isInvalid={
                                touched.responsable && errors.responsable
                              }
                              isValid={
                                touched.responsable && !errors.responsable
                              }
                              onBlur={handleBlur("responsable")}
                              placeholder="Seleccione un responsable"
                              options={employeesOptions}
                              onChange={(selected) => {
                                setFieldValue(
                                  "responsable",
                                  selected.length > 0 ? selected[0].id : ""
                                );
                                setEmpSelected(selected);
                              }}
                              selected={empSelected}
                              disabled={
                                loaderPersonResponsible ||
                                employeesOptions.length === 0 ||
                                // (edit &&
                                //   editItem.campania &&
                                //   editItem.list_campania[0].estado &&
                                //   editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //     "cerrado")
                                (edit &&
                                  editItem.estado &&
                                  editItem.list_estado[0].descripcion.toLowerCase() ===
                                    "cerrado")
                              }
                            ></Typeahead>
                            {touched.responsable && !!errors.responsable && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.responsable}
                                </small>
                              </div>
                            )}
                          </Col>
                          {loaderPersonResponsible && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Form.Group>
                    </Row>
                  </Tab>

                  <Tab eventKey="fecha" title="Fechas">
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Fecha de inicio
                            </Form.Label>
                            <Form.Control
                              id="fecha_inicio"
                              name="fecha_inicio"
                              isInvalid={
                                (touched.fecha_inicio && errors.fecha_inicio) ||
                                (touched.fecha_inicio &&
                                  values.fecha_inicio !== "" &&
                                  values.fecha_fin !== "" &&
                                  moment(values.fecha_inicio) >
                                    moment(values.fecha_fin))
                              }
                              isValid={
                                (touched.fecha_inicio &&
                                  !errors.fecha_inicio) ||
                                (touched.fecha_inicio &&
                                  !(
                                    values.fecha_inicio !== "" &&
                                    values.fecha_fin !== "" &&
                                    moment(values.fecha_inicio) >
                                      moment(values.fecha_fin)
                                  ))
                              }
                              onBlur={handleBlur("fecha_inicio")}
                              onChange={handleChange}
                              value={values.fecha_inicio}
                              type="date"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.fecha_inicio && !!errors.fecha_inicio && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.fecha_inicio}
                                </small>
                              </div>
                            )}
                            {values.fecha_inicio !== "" &&
                              values.fecha_fin !== "" &&
                              moment(values.fecha_inicio) >
                                moment(values.fecha_fin) && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    **La fecha inicio no pueder ser mayor a la
                                    fecha fin
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">Fecha fin</Form.Label>
                        <Form.Control
                          id="fecha_fin"
                          name="fecha_fin"
                          isInvalid={
                            (touched.fecha_fin && errors.fecha_fin) ||
                            (touched.fecha_fin &&
                              values.fecha_inicio !== "" &&
                              values.fecha_fin !== "" &&
                              moment(values.fecha_inicio) >
                                moment(values.fecha_fin))
                          }
                          isValid={
                            (touched.fecha_fin && !errors.fecha_fin) ||
                            (touched.fecha_fin &&
                              !(
                                values.fecha_inicio !== "" &&
                                values.fecha_fin !== "" &&
                                moment(values.fecha_inicio) >
                                  moment(values.fecha_fin)
                              ))
                          }
                          onBlur={handleBlur("fecha_fin")}
                          onChange={handleChange}
                          value={values.fecha_fin}
                          type="date"
                          className="rounded-pill"
                          disabled={
                            edit &&
                            // editItem.campania &&
                            // editItem.list_campania[0].estado &&
                            // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            editItem.estado &&
                            userRoles.length > 0 &&
                            !userRoles.some((role) =>
                              [
                                "administrador",
                                "Responsable_Capacitacion",
                              ].includes(role)
                            ) &&
                            editItem.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                        />
                        {touched.fecha_fin && !!errors.fecha_fin && (
                          <div className="px-2">
                            <small className="text-danger">
                              {errors.fecha_fin}
                            </small>
                          </div>
                        )}
                        {values.fecha_inicio !== "" &&
                          values.fecha_fin !== "" &&
                          moment(values.fecha_inicio) >
                            moment(values.fecha_fin) && (
                            <div className="px-2">
                              <small className="text-danger">
                                **La fecha inicio no pueder ser mayor a la fecha
                                fin
                              </small>
                            </div>
                          )}
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Nota aprobatoria
                            </Form.Label>
                            <Form.Control
                              id="nota_aprovatoria"
                              name="nota_aprovatoria"
                              isInvalid={
                                touched.nota_aprovatoria &&
                                errors.nota_aprovatoria
                              }
                              isValid={
                                touched.nota_aprovatoria &&
                                !errors.nota_aprovatoria
                              }
                              onBlur={handleBlur("nota_aprovatoria")}
                              onChange={handleChange}
                              value={values.nota_aprovatoria}
                              type="number"
                              min={0}
                              max={100}
                              required
                              placeholder="0"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {!errors.nota_aprovatoria && (
                              <div className="px-2">
                                <small className="text-info">**Opcional</small>
                              </div>
                            )}
                            {touched.nota_aprovatoria &&
                              !!errors.nota_aprovatoria && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.nota_aprovatoria}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">
                          Hora de inicio de capacitación
                        </Form.Label>
                        <Form.Control
                          id="hora_capacitacion"
                          name="hora_capacitacion"
                          isInvalid={
                            touched.hora_capacitacion &&
                            errors.hora_capacitacion
                          }
                          isValid={
                            touched.hora_capacitacion &&
                            !errors.hora_capacitacion
                          }
                          onBlur={handleBlur("hora_capacitacion")}
                          onChange={handleChange}
                          value={values.hora_capacitacion}
                          type="time"
                          min={0}
                          className="rounded-pill"
                          disabled={
                            edit &&
                            // editItem.campania &&
                            // editItem.list_campania[0].estado &&
                            // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            editItem.estado &&
                            editItem.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                        />
                        {touched.hora_capacitacion &&
                          !!errors.hora_capacitacion && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.hora_capacitacion}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Horas de dúracion
                            </Form.Label>
                            <Form.Control
                              id="duracion_horas"
                              name="duracion_horas"
                              isInvalid={
                                touched.duracion_horas && errors.duracion_horas
                              }
                              isValid={
                                touched.duracion_horas && !errors.duracion_horas
                              }
                              onBlur={handleBlur("duracion_horas")}
                              onChange={handleChange}
                              value={values.duracion_horas}
                              type="number"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.duracion_horas &&
                              !!errors.duracion_horas && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.duracion_horas}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">
                          Horas cumplidas
                        </Form.Label>
                        <Form.Control
                          id="horas_cumplidas"
                          name="horas_cumplidas"
                          isInvalid={
                            touched.horas_cumplidas && errors.horas_cumplidas
                          }
                          isValid={
                            touched.horas_cumplidas && !errors.horas_cumplidas
                          }
                          onBlur={handleBlur("horas_cumplidas")}
                          onChange={handleChange}
                          value={values.horas_cumplidas}
                          // value={
                          //   values.numero_empleados_recibir *
                          //   (values.porcentaje_asistencia / 100) *
                          //   values.duracion_horas
                          // }
                          type="number"
                          className="rounded-pill"
                          disabled
                        />
                        {touched.horas_cumplidas &&
                          !!errors.horas_cumplidas && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.horas_cumplidas}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Horas metas
                            </Form.Label>
                            <Form.Control
                              id="meta_horas"
                              name="meta_horas"
                              isInvalid={
                                touched.meta_horas && errors.meta_horas
                              }
                              isValid={touched.meta_horas && !errors.meta_horas}
                              onBlur={handleBlur("meta_horas")}
                              onChange={handleChange}
                              value={values.meta_horas}
                              // value={parseFloat(
                              //   values.numero_empleados_recibir *
                              //     (values.porcentaje_asistencia / 100) *
                              //     values.duracion_horas
                              // ).toFixed(2)}
                              type="number"
                              className="rounded-pill"
                              disabled
                            />
                            {touched.meta_horas && !!errors.meta_horas && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.meta_horas}
                                </small>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Form.Group>
                    </Row>
                  </Tab>

                  <Tab eventKey="evento" title="Detalle evento">
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">Objetivo</Form.Label>
                            <Form.Control
                              id="objetivo_capacitacion"
                              name="objetivo_capacitacion"
                              isInvalid={
                                touched.objetivo_capacitacion &&
                                errors.objetivo_capacitacion
                              }
                              isValid={
                                touched.objetivo_capacitacion &&
                                !errors.objetivo_capacitacion
                              }
                              onBlur={handleBlur("objetivo_capacitacion")}
                              onChange={handleChange}
                              value={values.objetivo_capacitacion}
                              // type="text"
                              as="textarea"
                              className="rounded"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.objetivo_capacitacion &&
                              !!errors.objetivo_capacitacion && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.objetivo_capacitacion}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">Tema</Form.Label>
                            <Form.Control
                              id="tema_capacitacion"
                              name="tema_capacitacion"
                              isInvalid={
                                touched.tema_capacitacion &&
                                errors.tema_capacitacion
                              }
                              isValid={
                                touched.tema_capacitacion &&
                                !errors.tema_capacitacion
                              }
                              onBlur={handleBlur("tema_capacitacion")}
                              onChange={handleChange}
                              value={values.tema_capacitacion}
                              // type="text"
                              as="textarea"
                              className="rounded"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.tema_capacitacion &&
                              !!errors.tema_capacitacion && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.tema_capacitacion}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">Impartido por</Form.Label>
                        <Form.Control
                          id="impartido_por"
                          name="impartido_por"
                          isInvalid={
                            touched.impartido_por && errors.impartido_por
                          }
                          isValid={
                            touched.impartido_por && !errors.impartido_por
                          }
                          onBlur={handleBlur("impartido_por")}
                          onChange={handleChange}
                          value={values.impartido_por}
                          type="text"
                          className="rounded-pill"
                          disabled={
                            edit &&
                            // editItem.campania &&
                            // editItem.list_campania[0].estado &&
                            // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            editItem.estado &&
                            editItem.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                        />
                        {touched.impartido_por && !!errors.impartido_por && (
                          <div className="px-2">
                            <small className="text-danger">
                              {errors.impartido_por}
                            </small>
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Facilitador
                            </Form.Label>
                            <Form.Control
                              id="facilitador"
                              name="facilitador"
                              isInvalid={
                                touched.facilitador && errors.facilitador
                              }
                              isValid={
                                touched.facilitador && !errors.facilitador
                              }
                              onBlur={handleBlur("facilitador")}
                              onChange={handleChange}
                              value={values.facilitador}
                              type="text"
                              className="rounded-pill"
                              disabled={
                                edit &&
                                // editItem.campania &&
                                // editItem.list_campania[0].estado &&
                                // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                                //   "cerrado"
                                editItem.estado &&
                                editItem.list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                            />
                            {touched.facilitador && !!errors.facilitador && (
                              <div className="px-2">
                                <small className="text-danger">
                                  {errors.facilitador}
                                </small>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">
                          Costo de capacitación
                        </Form.Label>
                        <Form.Control
                          id="costo_capacitacion"
                          name="costo_capacitacion"
                          isInvalid={
                            touched.costo_capacitacion &&
                            errors.costo_capacitacion
                          }
                          isValid={
                            touched.costo_capacitacion &&
                            !errors.costo_capacitacion
                          }
                          onBlur={handleBlur("costo_capacitacion")}
                          onChange={handleChange}
                          value={values.costo_capacitacion}
                          type="number"
                          className="rounded-pill"
                          disabled={
                            edit &&
                            // editItem.campania &&
                            // editItem.list_campania[0].estado &&
                            // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            editItem.estado &&
                            editItem.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                        />
                        {!errors.costo_capacitacion && (
                          <div className="px-2">
                            <small className="text-info">**Opcional</small>
                          </div>
                        )}
                        {touched.costo_capacitacion &&
                          !!errors.costo_capacitacion && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.costo_capacitacion}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Costo por empleado
                            </Form.Label>
                            <Form.Control
                              id="costo_empleado"
                              name="costo_empleado"
                              isInvalid={
                                touched.costo_empleado && errors.costo_empleado
                              }
                              isValid={
                                touched.costo_empleado && !errors.costo_empleado
                              }
                              onBlur={handleBlur("costo_empleado")}
                              onChange={handleChange}
                              value={values.costo_empleado}
                              type="number"
                              className="rounded-pill"
                              disabled
                            />
                            {touched.costo_empleado &&
                              !!errors.costo_empleado && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.costo_empleado}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">
                          Número de empleados a recibir
                        </Form.Label>
                        <Form.Control
                          id="numero_empleados_recibir"
                          name="numero_empleados_recibir"
                          isInvalid={
                            (touched.numero_empleados_recibir &&
                              errors.numero_empleados_recibir) ||
                            (touched.numero_empleados_recibir &&
                              edit &&
                              trainingAssistance &&
                              trainingAssistance.count >
                                parseInt(values.numero_empleados_recibir))
                          }
                          isValid={
                            (touched.numero_empleados_recibir &&
                              !errors.numero_empleados_recibir) ||
                            (touched.numero_empleados_recibir &&
                              edit &&
                              !(
                                trainingAssistance &&
                                trainingAssistance.count >
                                  parseInt(values.numero_empleados_recibir)
                              ))
                          }
                          onBlur={handleBlur("numero_empleados_recibir")}
                          onChange={handleChange}
                          value={values.numero_empleados_recibir}
                          type="number"
                          className="rounded-pill"
                          disabled={
                            edit &&
                            // editItem.campania &&
                            // editItem.list_campania[0].estado &&
                            // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            editItem.estado &&
                            editItem.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                        />
                        {touched.numero_empleados_recibir &&
                          !!errors.numero_empleados_recibir && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.numero_empleados_recibir}
                              </small>
                            </div>
                          )}
                        {edit &&
                          trainingAssistance &&
                          trainingAssistance.count >
                            parseInt(values.numero_empleados_recibir) && (
                            <div className="px-2">
                              <small className="text-danger">
                                **El número de empleados a recibir no puede ser
                                menor al total de personas agregadas a la lista
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Row className="align-items-end">
                          <Col>
                            <Form.Label className="ml-2">
                              Porcentaje de asistencia
                            </Form.Label>
                            <Form.Control
                              id="porcentaje_asistencia"
                              name="porcentaje_asistencia"
                              isInvalid={
                                touched.porcentaje_asistencia &&
                                errors.porcentaje_asistencia
                              }
                              isValid={
                                touched.porcentaje_asistencia &&
                                !errors.porcentaje_asistencia
                              }
                              onBlur={handleBlur("porcentaje_asistencia")}
                              onChange={handleChange}
                              value={values.porcentaje_asistencia}
                              type="number"
                              className="rounded-pill"
                              disabled
                            />
                            {touched.porcentaje_asistencia &&
                              !!errors.porcentaje_asistencia && (
                                <div className="px-2">
                                  <small className="text-danger">
                                    {errors.porcentaje_asistencia}
                                  </small>
                                </div>
                              )}
                          </Col>
                        </Row>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} className="mx-2 my-3">
                        <div className="d-flex aling-items-center justify-content-between px-1 pt-3">
                          <label htmlFor="es_evaluacion">
                            ¿Cambiar días para la aplicación de la evaluación?
                          </label>
                          <Form.Check
                            id="es_evaluacion"
                            name="es_evaluacion"
                            isInvalid={
                              touched.es_evaluacion && errors.es_evaluacion
                            }
                            isValid={
                              touched.es_evaluacion && !errors.es_evaluacion
                            }
                            onBlur={handleBlur("es_evaluacion")}
                            onChange={(e) => {
                              setFieldValue("es_evaluacion", e.target.checked);
                            }}
                            value={values.es_evaluacion}
                            className="rounded-pill"
                            type="switch"
                            defaultChecked={
                              edit ? editItem.es_evaluacion : null
                            }
                            disabled={
                              edit &&
                              // editItem.campania &&
                              // editItem.list_campania[0].estado &&
                              // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                              //   "cerrado"
                              editItem.estado &&
                              editItem.list_estado[0].descripcion.toLowerCase() ===
                                "cerrado"
                            }
                          />
                          {touched.es_evaluacion && errors.es_evaluacion && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.es_evaluacion}
                              </small>
                            </div>
                          )}
                        </div>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label className="ml-2">
                          Días para aplicar evaluación
                        </Form.Label>
                        <Form.Control
                          id="dias_evaluacion"
                          name="dias_evaluacion"
                          isInvalid={
                            touched.dias_evaluacion && errors.dias_evaluacion
                          }
                          isValid={
                            touched.dias_evaluacion && !errors.dias_evaluacion
                          }
                          onBlur={handleBlur("dias_evaluacion")}
                          onChange={handleChange}
                          value={values.dias_evaluacion}
                          type="number"
                          className="rounded-pill"
                          disabled={
                            !values.es_evaluacion ||
                            // (edit &&
                            //   editItem.campania &&
                            //   editItem.list_campania[0].estado &&
                            //   editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //     "cerrado")
                            (edit &&
                              editItem.estado &&
                              editItem.list_estado[0].descripcion.toLowerCase() ===
                                "cerrado")
                          }
                        />
                        {touched.dias_evaluacion &&
                          !!errors.dias_evaluacion && (
                            <div className="px-2">
                              <small className="text-danger">
                                {errors.dias_evaluacion}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                    </Row>
                  </Tab>
                </Tabs>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                {/* {!edit ||
                (edit &&
                  editItem.campania &&
                  editItem.list_campania[0].estado &&
                  editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() !==
                    "cerrado") ? ( */}
                {!edit ||
                (edit &&
                  editItem.estado &&
                  editItem.list_estado[0].descripcion.toLowerCase() !==
                    "cerrado") ||
                (userRoles.length > 0 &&
                  (userRoles.includes("administrador") ||
                    userRoles.includes("Responsable_Capacitacion"))) ? (
                  <Button
                    className="rounded-pill"
                    disabled={
                      saveLoaderTrainingEvents ||
                      (loaderTrainingAssistance &&
                        userRoles.length > 0 &&
                        !userRoles.includes("administrador"))
                    }
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderTrainingEvents || loaderTrainingAssistance ? (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : null}
                    Guardar
                  </Button>
                ) : null}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      <Modal
        show={showModalAcceptEstado}
        onHide={() => setShowModalAcceptEstado(false)}
      >
        <Formik
          validationSchema={schemaAcceptEstado}
          onSubmit={onSubmit}
          initialValues={{
            dias: edit ? (editItem.dias ? editItem.dias : "") : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">Abrir estado</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!trainingEventsFormError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {trainingEventsFormError}
                  </Alert>
                )}
                <Row>
                  <Form.Group as={Col}>
                    <Row className="align-items-end">
                      <Col>
                        <Form.Label className="ml-2">Extender días</Form.Label>
                        <Form.Control
                          id="dias"
                          name="dias"
                          isInvalid={touched.dias && errors.dias}
                          isValid={touched.dias && !errors.dias}
                          onBlur={handleBlur("dias")}
                          onChange={handleChange}
                          value={values.dias}
                          type="text"
                          className="rounded-pill"
                          disabled={
                            edit &&
                            // editItem.campania &&
                            // editItem.list_campania[0].estado &&
                            // editItem.list_campania[0].list_estado[0].descripcion.toLowerCase() ===
                            //   "cerrado"
                            editItem.estado &&
                            editItem.list_estado[0].descripcion.toLowerCase() ===
                              "cerrado"
                          }
                        />
                        {touched.dias && !!errors.dias && (
                          <div className="px-2">
                            <small className="text-danger">{errors.dias}</small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalAcceptEstado(false)}
                >
                  Cerrar
                </Button>
                {/* {editItem.estado && ( */}
                <>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderTrainingEvents}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderTrainingEvents && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    {/* {editItem.list_tipo_evaluacion[0].nombre === "90°"
                        ? "Aceptar"
                        : "Guardar"} */}
                    Aceptar
                  </Button>
                </>
                {/* // )} */}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/*Modal*/}
    </>
  );
};

export default TrainingEvents;
